// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1tTcA","itemTitle":"ClientEmergencyInfo_itemTitle__3gTGd","itemText":"ClientEmergencyInfo_itemText__1jIJs"};